import { publishNotifications } from "ecp-notifications-sc-publisher";
import { createLogger } from "./utils/logger";
import { NOTIFICATION_FILTERS } from "./constants";
const logger = createLogger("PublishNotification");

type PublishResponse = {
  success?: boolean;
  error?: unknown;
};

async function publishNotification(
  token: string,
  env: string,
  title: string,
  message: string,
  priority: string,
  category: string,
): Promise<unknown> {
  
  const appId = import.meta.env.VITE_OIDC_CLIENT_ID || "scpe-dd-sep-dev";
  const platformId = "AIDE_0082245";

  const notificationFilters = sessionStorage.getItem("notificationFilters");

  const publishPayload = {
    recipient: null,
    target: [
      {
        channel: "web",
        applications: [
          {
            appId,
            appName: "Template Studio",
            filters: notificationFilters ? JSON.parse(notificationFilters) : [`${NOTIFICATION_FILTERS.TEMPLATE_FILTERS}`],
          },
        ],
      },
    ],
    notification: {
      title,
      message,
      priority,
      category,
    },
  };


  try {
    const result = (await publishNotifications(
      token,
      env,
      platformId,
      publishPayload,
    )) as PublishResponse;

    if (result?.success === false) {
      logger.error(
        "Notification publish returned unsuccessful response:",
        result.error ?? result,
      );
      throw new Error("Notification publish API returned success=false");
    }

    return result;
  } catch (error) {
    logger.error("Failed to publish notification:", error);
    throw error;
  }
}

export default publishNotification;
